import { render, staticRenderFns } from "./PricesShowAllLink.vue?vue&type=template&id=79709452&"
import script from "./PricesShowAllLink.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricesShowAllLink.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79709452')) {
      api.createRecord('79709452', component.options)
    } else {
      api.reload('79709452', component.options)
    }
    module.hot.accept("./PricesShowAllLink.vue?vue&type=template&id=79709452&", function () {
      api.rerender('79709452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesShowAllLink.vue"
export default component.exports